import { CRUD, CrudModel } from '../../classes'
import { BaseModelData } from '../base-model-data'

export interface PayerGroupData extends BaseModelData {
  name: string
}

@CRUD({
  base: '/crud/payer-group',
})
export class PayerGroup extends CrudModel {
  name: string

  constructor(data: PayerGroupData) {
    super(data, true)
  }

  get isGlobal(): boolean {
    return !this.clinicId
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      name: this.name,
    }
  }
}
